<template>
    <div class="modal__buttons text-center text-md-right central-buttons">
        <button type="button" class="modal__buttons__item cancel" data-dismiss="modal" aria-label="Close" v-html="'Cancel'" @click="cancel()"/>
        <button class="modal__buttons__item mr-1" v-html="`Save & new <img class='ml-2' width='15px' src='/assets/img/svg/add-w.svg' alt=''/>`" @click="clicking();"/>
        <button class="modal__buttons__item" v-html="`Save & close <img class='ml-2' width='15px' src='/assets/img/svg/add-w.svg' alt=''/>`" @click="save_and_close(); clicking();"/>
        <!-- <button class="modal__buttons__item" v-html="`Save & continue <img class='ml-2' width='15px' src='/assets/img/svg/add-w.svg' alt=''/>`"/> -->
    </div>
</template>

<script>
import eventBus from '../plugins/eventBus'

export default {
    name: 'CentralButtons',

    props: [
        'ext'
    ],

    data() {
        return {
            close: false,
            clicked: false
        }
    },

    async created() {

        eventBus.$on('spliceObject', () => {
            if (this.clicked)
            {
                this.revoke_loader_with_close('patch', this.close, this.ext)
                this.close = false
                this.clicked = false
            }
        })

        eventBus.$on('unshiftObject', () => {
            if (this.clicked)
            {
                this.revoke_loader_with_close('post', this.close, this.ext)
                this.close = false
                this.clicked = false
            }
        })
    },
    
    methods: {
        cancel()
        {
            this.$emit('Cancelation')
        },

        save_and_close()
        {
            this.close = true
            eventBus.$emit('save_and_new', !this.close )
        },

        clicking()
        {
            this.clicked = true
        }
    },
    
}
</script>